import React, { useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import closeIconBlack from "../../assets/images/chats/closeLogoBlack.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CloseButton, CloseIcon } from "../../page/Profille/CustomDrawer";
import AlertPopUp from "../../common/AlertPopUp";

const ExitAccountPopup = ({
  closePopUp,
  handleConfirm,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isPermissionModalOpen, setPermissionModal] = useState(false);

  return (
    <>
      <AlertPopUp
        title={"Access Denied ."}
        bodyContent={appContent?.KEY168}
        open={isPermissionModalOpen}
        closeModal={() => setPermissionModal(false)}
      />

      <Box
        sx={{ zIndex: 1204 }}
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        bgcolor="rgba(0, 0, 0, 0.7)"
      >
        <Box
          zIndex={10}
          position="absolute"
          bgcolor="#FFFFFF"
          width={"30rem"}
          padding={"1.75rem"}
          top="27%"
          left="38%"
          transform={`translate(-50%, -50%)`}
          boxShadow="0px 3px 3px rgba(0,0,0,0.25)"
          borderRadius={"0.12rem"}
        >
          {/* TOP HEADER */}
          <Box display={"flex"} gap={"0.6rem"}>
            <CloseButton onClick={closePopUp}>
              <CloseIcon src={closeIconBlack} alt="close" />
            </CloseButton>

            <Typography fontSize={"1.2rem"} variant="h6">
              Exit Account
            </Typography>
          </Box>

          {/* BODY TEXT */}
          <Box width={"81.8%"} margin={"auto"}>
            <Typography
              mt={"0.5rem"}
              fontWeight={"400"}
              fontSize={"0.85rem"}
              variant="h6"
              color={"#183242"}
              textAlign={"start"}
            >
              If you exit this account, you’ll be removed from all its groups. You can rejoin only if the admin invites you again. Your DMs will remain available unless you manually remove them.
            </Typography>

            {/* BUTTON */}
            <Box display="flex" justifyContent="center" mt="1.2rem">
              <Button
                onClick={handleConfirm}
                sx={{
                  textTransform: "none",
                  padding: "5px 10px",
                  color: "#020202ff",
                  border: "1px solid #020202ff",
                  borderRadius: "0.15rem",
                }}
              >
                Exit
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ExitAccountPopup;
